/**
 * @generated SignedSource<<baf33198c2c9b17e39384b3f49c7d68f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_user">;
  readonly " $fragmentType": "MessageBannerCarousel_user";
};
export type MessageBannerCarousel_user$key = {
  readonly " $data"?: MessageBannerCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageBannerCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBannerCarousel_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "messageHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ad75389f188c3ae38f2aeb10fbe49cf0";

export default node;
